/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import PopProductShipLotCreateDialog from "../dialogTypes/PopProductShipLotCreateDialog";
import PopProductShipOfOrderBuyerLotCreateDialog from "../dialogTypes/PopProductShipOfOrderBuyerLotCreateDialog";

function PopProductShipOfOrderBuyerLotCreateButton ( props ) {
    const {id, grid, schema, refresh, materialSelect, onSuccess, ...others} = props;
    const [open, setOpen] = useState(false);
    const {t} = useTranslation();
    
    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <PopProductShipOfOrderBuyerLotCreateDialog
                id={id+"append-dialog"}
                title={t(`dialog.title.${schema.name}.create`)}
                grid={grid}
                schema={schema}
                materialSelect={materialSelect}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default PopProductShipOfOrderBuyerLotCreateButton;

